import React, {Component} from "react";
import {connect} from "react-redux";
import {TwitchPlayer} from "react-twitch-embed";
import Interactive from "../../components/UI/Interactive";
import './LiveStream.scss';

import * as actions from "../../store/actions/actions";
import {getCookie} from "../../store/actions/actions";

export class LiveStream extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isClient: false,
            width: window.innerWidth,
            height: window.innerHeight,
            timer: 5,
            showModal: false,
            displayTimer: '',
        };

        let user = getCookie('user');
        if (user) {
            user = JSON.parse(user);
            this.props.setUser(user);
        }

        this.updateWindowDimensions = this.updateWindowDimensions.bind(this);
    }

    componentDidMount() {
        this.updateWindowDimensions();
        this.props.getSettings();
        if (!this.props.client.code) {
            this.props.preloadClient(this.props.history);
        }
        this.setState({isClient: true})

        let show = Number(this.props.match.params.show);
        if (show) this.props.setSelectedShow(show);

        window.addEventListener('resize', this.updateWindowDimensions);
        this.timer();

        if (this.props.client && this.props.client.shows.length) {
            this.props.getShow(this.props.client.shows[0].id);
        }
    }

    componentDidUpdate(prevProps) {

        if (this.props.client && this.props.client.shows.length
            && !prevProps.client.shows.length) {
            let show = Number(this.props.match.params.show);
            if (show && this.props.client.shows.filter(s => {
                return s.id === show;
            }).length) {
                this.props.getShow(show);
            } else {
                this.props.getShow(this.props.client.shows[0].id);
            }
        }

        if (this.props.show.id !== prevProps.show.id) {
            return {
                timer: this.props.show.show_in_sec
            }
        }
    }

    componentWillUnmount() {
        clearInterval(this.myInterval);
        window.removeEventListener('resize', this.updateWindowDimensions);
    }

    updateWindowDimensions() {
        let width, height;
        if (window.innerWidth < window.innerHeight) {
            //mobile
            width = window.innerWidth - 20;
            height = width * 3 / 4;
        } else {
            //desktop
            width = Math.min(window.innerHeight * 0.66 * 16 / 9, window.innerWidth * 0.75 - 54);
            height = width * 9 / 16;
        }
        this.setState({
            ...this.state,
            width: Math.floor(width),
            height: Math.floor(height)
        });
    }

    timer = () => {
        if (this.state.timer > 0) {
            let displayTimer = new Date(this.state.timer * 1000).toISOString().substr(11, 8);
            this.setState({timer: this.state.timer - 1, displayTimer: displayTimer, showModal: true})
            setTimeout(this.timer, 1000);
        } else {
            this.props.setShowView(true);
            this.setState({showModal: false})
        }
    };

    streamOnline = () => {
        let snd = new Audio("data:audio/wav;base64,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");
        snd.play();
    }

    render() {
        return (
            <div className={'live-container'}>
                <div className={'live-stream'}>
                    {!this.state.showModal && this.props.show.video_channel ?
                        (this.props.show.video_type === 'TWITCH' ? (
                                <TwitchPlayer channel={this.props.show.video_channel}
                                              allowFullScreen={true}
                                              height={this.state.height}
                                              width={this.state.width} hideControls={true}
                                              muted={false}
                                              onOnline={this.streamOnline}
                                              parent={["livem.tv"]} border={0}/>) :
                            <div className={'iframe-container'}
                                 style={{height: this.state.height, width: this.state.width}}
                                 dangerouslySetInnerHTML={{__html: this.props.show.video_channel}}/>)
                        : (
                            this.state.showModal ? <div className="live-timing p-3">
                                <div className="bg-dark rounded d-inline-flex flex-column p-3 ">
                                    <div className="d-flex justify-content-center"><h6>:השידור יתחיל בעוד</h6></div>
                                    <div className="d-flex justify-content-center">
                                        <h4>
                                            {this.state.displayTimer}
                                        </h4>
                                    </div>
                                </div>
                            </div> : ''
                        )}
                </div>
                <Interactive/>
            </div>
        );
    }
}

const mapStateToProps = (state) => {
    return state.auth;
};

const mapDispatchToProps = (dispatch, state) => {
    return {
        setSelectedShow: (id) => dispatch(actions.setSelectedShow(id)),
        getShow: (id) => dispatch(actions.getShow(id)),
        preloadClient: (history) => dispatch(actions.preloadClient(history)),
        getSettings: () => dispatch(actions.getSettings()),
        setUser: (user) => dispatch(actions.setUser(user)),
        setShowView: (flag) => dispatch(actions.setShowView(flag)),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(LiveStream);
